import { ModalCustom } from '@esg/ui';
import React from 'react';
import { useAtom } from 'jotai';
import { subModalState } from '@esg/framework';


export const SubModal = () => {
    const [modalState, setModalState] = useAtom(subModalState);
    const resetSubModalState = () => setModalState(subModalState.init);

    return (
        <ModalCustom
            onCancel={resetSubModalState}
            open={modalState?.isOpen}
            title={modalState?.titleTransCode}
            footer={modalState?.footer}
            destroyOnClose
            closeIcon={modalState?.closeIcon}
            cancelText={modalState?.cancelText}
            okText={modalState?.okText}
            width={modalState?.width}
            onOk={modalState?.onOk}
            showDivider={modalState?.showDivider}
            maskClosable={modalState?.maskClosable}
            okButtonProps={{
                style: { backgroundColor: modalState?.backgroundColorBtn, borderColor: modalState?.backgroundColorBtn }
            }}
        >
            {modalState?.content}
        </ModalCustom>
    );
};
